import React, { useEffect, useRef, useState, useMemo } from "react";

import {
  Gantt,
  EventOption,
  StylingOption,
  ViewMode,
  DisplayOption,
} from "gantt-task-react";
import "gantt-task-react/dist/index.css";
import Typography from "@mui/material/Typography";
import { Box, Stack } from "@mui/material";
import { useFormContext } from "react-hook-form";

const TimelineComponent = ({ equipId, rows }) => {
  // const [dashboardData, setDashboardData] = useState({})
  // // const [dataFetched, setDataFetched] = useState(false)
  // const { getValues } = useFormContext();

  console.log(rows);

  const formattedData = rows.map((row, index) => ({
    id: row.id || index,
    name: row?.plannedEnd ? row?.name : "",
    start: row?.plannedStart ? new Date(row?.plannedStart) : new Date(),
    end: row?.plannedEnd ? new Date(row?.plannedEnd) : new Date(),
    progress: Number(row?.progress) || 0,
  }));

  console.log("fffffffff", { formattedData });
  const { minDate, maxDate } = useMemo(() => {
    if (!formattedData.length)
      return { minDate: new Date(), maxDate: new Date() };

    const starts = formattedData.map((t) => t.start.getTime());
    const ends = formattedData.map((t) => t.end.getTime());
    const min = new Date(Math.min(...starts));
    const max = new Date(Math.max(...ends));

    // add a small buffer (e.g., ±3 days)
    const buffer = 3 * 24 * 60 * 60 * 1000;
    return {
      minDate: new Date(min.getTime() - buffer),
      maxDate: new Date(max.getTime() + buffer),
    };
  }, [formattedData]);

  return (
    <Box sx={{ width: "inherit" }}>
      <Box sx={{ backgroundColor: "#FFFF", p: 1 }}>
        <Typography
          variant="h6"
          color="text.secondary"
          sx={{ pb: 1, textAlign: "center" }}
        >
          Planned Timeline
        </Typography>
        {formattedData?.length > 0 ? (
          <Gantt
            tasks={formattedData}
            viewMode={"Month"}
            columnWidth={150}
            listCellWidth={""}
            rowHeight={49.95}
            headerHeight={55}
            preStepsCount={0}
            // ganttHeight
            startDate={minDate}
            endDate={maxDate}
          />
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export default TimelineComponent;
